import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import ConnectionData from './ConnectionData';
import ConnectionDataTabState from './ConnectionDataTabState';

export default class ConnectionDataTabView extends BufferTabView<ConnectionDataTabState> {
  render(): this {
    const props = {
      connectionId: this.model.get('connectionId'),
    };
    renderToDOM(
      <div className="react-tab-container">
        <ConnectionData {...props} />
      </div>,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<ConnectionDataTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ConnectionDataTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
